<template>
  <div>
    <h1>Pagina niet gevonden</h1>
    <p>
      We hebben de pagina niet gevonden.<br/><br/>
      <router-link :to="{ name: 'Start' }">Terug naar home</router-link>
    </p>
  </div>
</template>